export const calculateReadingTime = (text = '', wordsPerMinute = 200) => {
  if (!text || typeof text !== 'string') return 1;
  const words = text.trim().split(/\s+/).filter(Boolean);
  const minutes = Math.ceil(words.length / wordsPerMinute);
  return Math.max(minutes, 1);
};
